import { DraftPlaceholderTextConfiguration, DraftState, StoreFont } from '@/types';
import { getProductType } from '@/model/draft/getProductType';
import { getPrintAreaWidth } from '@/model/printArea/getPrintAreaSize';
import { addConfigurationToDraft } from './helper/addConfigurationToDraft';
import { getDefaultBox } from './helper/getDefaultBox';
import { getTextConfigurationBase } from './helper/getTextConfigurationBase';

export const addPlaceholderTextAction =
  (text: string, font: StoreFont, color: string) => (draft: DraftState) => {
    const textConfigurationBase = getTextConfigurationBase(draft, text, font, color);
    if (!textConfigurationBase) {
      // fonts are not supported on the current print area
      return;
    }

    const printArea = textConfigurationBase.printArea;
    const centerX = getPrintAreaWidth(printArea) / 2;
    const offsetY = getDefaultBox(
      printArea,
      textConfigurationBase.printType,
      getProductType(draft)
    ).y;
    const size = textConfigurationBase.size;

    const draftPlaceholderTextConfiguration: DraftPlaceholderTextConfiguration = {
      ...textConfigurationBase,
      type: 'placeholderText',
      placeholderSize: { ...size },
      placeholderCenter: { x: centerX, y: offsetY + size.height / 2 },
      placeholderFontSize: textConfigurationBase.text.style.fontSize,
    };

    addConfigurationToDraft(draft, draftPlaceholderTextConfiguration);
  };
